const NOTIFICATION_SEND_SUBSCRIPTION_PENDING = `NOTIFICATION_SEND_SUBSCRIPTION_PENDING`;
const NOTIFICATION_SEND_SUBSCRIPTION_SUCCESS = `NOTIFICATION_SEND_SUBSCRIPTION_SUCCESS`;
const NOTIFICATION_SEND_SUBSCRIPTION_ERROR = `NOTIFICATION_SEND_SUBSCRIPTION_ERROR`;

const NOTIFICATION_FETCH_PENDING = `NOTIFICATION_FETCH_PENDING`;
const NOTIFICATION_FETCH_SUCCESS = `NOTIFICATION_FETCH_SUCCESS`;
const NOTIFICATION_FETCH_ERROR = `NOTIFICATION_FETCH_ERROR`;

const EDIT_PENDING = "NOTIFICATION_EDIT_PENDING";
const EDIT_DONE = "NOTIFICATION_EDIT_DONE";

const NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_PENDING = `NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_PENDING`;
const NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_SUCCESS = `NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_SUCCESS`;
const NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_ERROR = `NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_ERROR`;

const NOTIFICATION_COPY_PENDING = `NOTIFICATION_COPY_PENDING`;
const NOTIFICATION_COPY_SUCCESS = `NOTIFICATION_COPY_SUCCESS`;
const NOTIFICATION_COPY_ERROR = `NOTIFICATION_COPY_ERROR`;

export default {
  NOTIFICATION_SEND_SUBSCRIPTION_PENDING,
  NOTIFICATION_SEND_SUBSCRIPTION_SUCCESS,
  NOTIFICATION_SEND_SUBSCRIPTION_ERROR,
  NOTIFICATION_FETCH_PENDING,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_ERROR,
  EDIT_PENDING,
  EDIT_DONE,
  NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_PENDING,
  NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_SUCCESS,
  NOTIFICATION_FETCH_RSS_SUBSCRIPTION_LINK_ERROR,
  NOTIFICATION_COPY_PENDING,
  NOTIFICATION_COPY_SUCCESS,
  NOTIFICATION_COPY_ERROR,
};
